import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'simulationTableFilter'
})
export class SimulationTableFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    let result = value.filter((x) => {
      return x.enabled;
    });

    return result;
  }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/pipes/simulation-table-filter.pipe.ts